module.exports = __webpack_public_path__ + "img/hakuna_step03.ae443dd0.png";